import React from 'react';
import { Button, Typography, Box, FlexBox, Grid, MuiBox } from '@kis-technologies/kis-ui';
import { SetUpList, SetUpListItem, useStyles } from './styled';
import SplashScreenImage from '../../../assets/splash_screen.png';
import packageJSON from '../../../../package.json';
import { useNavigate } from 'react-router-dom';
import { selectors as authSelectors, actions as authActions, DecodedJWT } from 'services/auth';
import { selectors as kioskSelectors, actions as kioskActions } from 'services/kiosk';
import { useActions } from 'hooks/useActions';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { LoadingOverlay } from 'components/LoadingOverlay';

const SetUpView = () => {
  const { demoLogin, resetKiosk } = useActions({
    demoLogin: authActions.demoLogin,
    resetKiosk: kioskActions.resetKiosk
  });
  const adminToken = useSelector(authSelectors.selectAdminId);
  const loading = useSelector(authSelectors.selectLoading);
  const kiosk = useSelector(kioskSelectors.selectKiosk);
  const classes = useStyles();
  const kioskId = sessionStorage.getItem('kioskId');
  const isPreviewMode = sessionStorage.getItem('mode') === 'preview';
  const token = sessionStorage.getItem('token');
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isPreviewMode && token) {
      resetKiosk();
      const decodedToken = jwtDecode<DecodedJWT>(token || '');
      if (decodedToken && decodedToken.adminId) {
        demoLogin({ kioskId, adminId: decodedToken.adminId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPreviewMode, kioskId, token]);

  React.useEffect(() => {
    if (adminToken && kiosk && kiosk.id === kioskId) {
      navigate('/systems');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminToken, kiosk]);

  return (
    <>
      {loading && <LoadingOverlay style={{ zIndex: '99' }} />}
      {!loading && (
        <Grid container spacing={0} className={classes.setupViewOuterContainer}>
          <Grid item md={12} xl={6} className={classes.setupViewImageContainer}>
            <FlexBox fullHeight fullWidth overflow="hidden">
              <img src={SplashScreenImage} alt="KIS KIOSK" width="100%" />
            </FlexBox>
          </Grid>
          <Grid item md={12} xl={6} className={classes.setupViewTextContainer}>
            <FlexBox bg="white" direction="column" raised fullHeight>
              <MuiBox className={classes.setupViewTextBlock}>
                <Box margin="0 0 6">
                  <Typography
                    sx={{ fontSize: '64px', lineHeight: '1.16', height: '148px' }}
                    fontWeight={800}
                  >{`Let's Setup Your KIS Kiosk`}</Typography>
                </Box>
                <Box width="90%">
                  <Box padding="4 0 7">
                    <Typography className={classes.setupViewSubHeading}>{`What You'll Need`}</Typography>
                  </Box>
                  <MuiBox className={classes.setupListItemBox}>
                    <SetUpList>
                      <SetUpListItem>Your Email Address</SetUpListItem>
                      <SetUpListItem>The Password That Was Emailed To You From KIS Technologies</SetUpListItem>
                    </SetUpList>
                  </MuiBox>
                </Box>
                <MuiBox className={classes.setupViewBeginButton}>
                  <Button
                    customSize="x-large"
                    radius="round"
                    href="/signin"
                    onClick={() => navigate('/signin')}
                    width={475}
                    endIconName="next_circle"
                    data-testid="begin-setup-button"
                  >
                    Touch to begin
                  </Button>
                </MuiBox>
                <Box sx={{ justifyContent: 'right' }}>
                  <Typography variant="body1" data-testid="versionNumber">
                    Version: {packageJSON.version}
                  </Typography>
                </Box>
              </MuiBox>
            </FlexBox>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default SetUpView;
